export const state = () => ({
    projects: [],
});

export const mutations = {
    setProjects(state: any, payload: any) {
        state.projects = payload;
    },
};

export const getters = {
    getProjects: (state: any) => state.projects,
};

export const actions = {
    async getProjects(state: any) {
        return new Promise((resolve, reject) => {
            this.$axios
                .get(`/api/wamly/projects`)
                .then((res) => {
                    state.commit('setProjects', res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    async linkProjectToJob(state: any, payload: any) {
        const { job_uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/jobs/${job_uuid}/wamly/projects`, data)
                .then((result) => {
                    // Update the job in the main view.
                    state.commit('jobs/single/setJobPost', result.data, { root: true });

                    // Update the selected job in the job sidebar.
                    state.commit('jobs/setSelectedJob', result.data, { root: true });

                    resolve(result.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    async addCandidateToProject(state: any, payload: any) {
        const { job_uuid, wamly_project_uuid, ...data } = payload;

        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/wamly/projects/${wamly_project_uuid}/candidates`, data)
                .then((result) => {
                    state.commit('applications/updateApplicants', result.data, { root: true });

                    resolve(result.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
